import { useGLTF } from '@react-three/drei';
import type { Euler, Vector3 } from '@react-three/fiber';
import type { ReactElement } from 'react';
import { useRef } from 'react';
import * as THREE from 'three';
import type { GLTF } from 'three-stdlib';

type GLTFResult = GLTF & {
  nodes: {
    koi: THREE.Mesh;
    sphere: THREE.Mesh;
  };
};
interface KoiProps {
  color?: string;
  position?: Vector3;
  scale?: Vector3;
  rotation?: Euler;
}

const Koi = ({ color, position, rotation, scale }: KoiProps): ReactElement => {
  const group = useRef<THREE.Group>(null);
  const refModel = useRef(null);

  const material = new THREE.MeshPhongMaterial({
    color: color || '#030303',
    shininess: 7,
  });
  // const material = new THREE.MeshPhysicalMaterial({
  //   color: color || '#000000',
  //   roughness: 0.9,
  // });

  const { nodes } = useGLTF('/assets/3d/Koi-draco.glb') as unknown as GLTFResult;
  // useUnmount(() => {
  //   disposeObject3D(nodes)
  // })

  return (
    <group ref={group} position={position} rotation={rotation} scale={scale} dispose={null}>
      <mesh
        ref={refModel}
        material={material}
        position={[0, 0, 0]}
        scale={[0.9, 0.9, 0.9]}
        rotation={[0, 0, 0]}
        castShadow
        receiveShadow
        geometry={nodes.koi.geometry}
        // rotation={[Math.PI / 2, 0, 0]}
      >
        <mesh geometry={nodes.sphere.geometry} material={material} position={[0.65, 1.08, -2.24]} />
      </mesh>
    </group>
  );
};

export default Koi;

// useGLTF.preload('/assets/3d/Koi-draco.glb');
